import React from "react";
import LocalizedLink from 'helpers/LocalizeLink';
import { useTranslation } from 'react-i18next';
import HeaderNavMenu from "./HeaderNavMenu";
import LanguageSelect from "../elements/LanguageSelect";

const HeaderNavBar = props => {
    const { t } = useTranslation();

    return (
        <>
            <HeaderNavMenu />
            <LanguageSelect />
            <LocalizedLink to={window.location.href.includes('/account_delete') ? '/auth?previous=0' : '/auth'} className="btn-auth head_menu-item text-white text-medium text-sm-big text-semibold px-2 pl-md-2 mt-4 mt-md-0 mx-auto ml-md-4 mr-md-0">
                {t('buttons.btn_login')} <span className="d-inline-block d-md-none text-white text-medium text-sm-big text-semibold">/ {t('buttons.btn_register')}</span>
            </LocalizedLink>
        </>
    )
}

export default HeaderNavBar;